"use strict";
// Canonical catalogue of domain event names consumed by the Assistant task engine.
// Adding a new event = one entry here + one emission site in the corresponding
// backend service.
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKnownEventName = exports.EVENT_NAMES_TUPLE = exports.EVENT_NAMES = void 0;
exports.EVENT_NAMES = {
    projectCreated: 'project.created',
    projectFileUploaded: 'project.file.uploaded',
    projectDocumentsReceived: 'project.documents.received',
    projectDeposited: 'project.deposited',
    projectSentToMairie: 'project.sent-to-mairie',
    formStatusChanged: 'project.form-status.changed',
    urbanAnalysisStatusChanged: 'urban-analysis.status.changed',
    // Folder-deadline reminders (folder-deadline-reminders branch).
    // `projectDepositDeadline` is emitted with `occurredAt = first_deposite_date
    // + instruction_delay` so the engine inserts a hidden task that surfaces
    // exactly when the legal decision deadline passes.
    projectDepositDeadline: 'project.deposit-recorded.deadline',
    projectAdministrativeDecisionRecorded: 'project.administrative-decision.recorded',
    // The COMMERCIAL reported the mairie's letter on a dossier they lodged
    // themselves (fork F8b). Distinct from `projectAdministrativeDecisionRecorded`,
    // which merely says *an* answer exists and closes the overdue reminder: this
    // one carries WHICH answer, and a MODIFICATION is work landing on the
    // architect's desk that nothing else would surface.
    projectMairieDecisionReported: 'project.mairie-decision.reported',
    // Fires once when a project reaches a terminal lifecycle state
    // (`PROJECT_COMPLETED` or `PROJECT_ABANDONED`). The folder-deadline reminders
    // (`dossier-decision-overdue`, `dossier-receipt-missing`) listen on this so
    // they auto-resolve when the dossier is no longer actionable, regardless of
    // whether the legacy decision/receipt paths fired.
    projectClosed: 'project.closed',
    // `urbanAnalysisThreeMonthTick` is emitted with `occurredAt = created + 3
    // months` for every new standalone urban analysis; surfaces a follow-up
    // task when 3 months elapse without conversion to a project.
    urbanAnalysisThreeMonthTick: 'urban-analysis.three-month-tick',
    urbanAnalysisValidated: 'urban-analysis.validated',
    urbanAnalysisLinkedToProject: 'urban-analysis.linked-to-project',
};
exports.EVENT_NAMES_TUPLE = Object.values(exports.EVENT_NAMES);
const isKnownEventName = (name) => exports.EVENT_NAMES_TUPLE.includes(name);
exports.isKnownEventName = isKnownEventName;
//# sourceMappingURL=event-names.js.map